/**
 * Tipos de errors tratados.
 *
 * @type {{'404': string, '403': string}}
 * @author Highlander Paiva
 * @since 1.0
 */
export const HttpError = {
  404: "Recurso não encontrado",
  403: "Acesso negado"
};
